import { FormEvent } from 'react';
import { FormControl } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import { Channel } from 'models/Channels';
import { Property } from 'models/Properties';
import { AirbnbFeeType } from 'models/PropertyFees';
import MappingTypeField from './MappingTypeField';
import { AIRBNB_UNIT_TYPE_OPTIONS_MAPPING } from './PropertyFeeModal.constants';
import useFieldsOptions from './useFieldsOptions';

interface AirbnbMappingTypeFieldProps {
  labelInputSizes: { colSmLabel: number; colSmInput: number };
  propertyUid: Property['uid'];
}

const AirbnbMappingTypeField = ({
  labelInputSizes,
  propertyUid,
}: AirbnbMappingTypeFieldProps) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  const { AIRBNB_OPTIONS } = useFieldsOptions();

  const handleTypeChange = (e: FormEvent<FormControl>) => {
    const type = (e.target as HTMLSelectElement).value;

    // Pre-selects the first airbnb unit mapping type option available.
    if (
      type === AirbnbFeeType.PASS_THROUGH_AIR_CONDITIONING_FEE ||
      type === AirbnbFeeType.PASS_THROUGH_ELECTRICITY_FEE ||
      type === AirbnbFeeType.PASS_THROUGH_HEATING_FEE ||
      type === AirbnbFeeType.PASS_THROUGH_UTILITY_FEE ||
      type === AirbnbFeeType.PASS_THROUGH_WATER_FEE
    ) {
      setValue(
        'airbnbUnitMappingType',
        AIRBNB_UNIT_TYPE_OPTIONS_MAPPING[type][0],
        {
          shouldDirty: true,
        },
      );
    }
  };

  return (
    <MappingTypeField
      name="airbnb"
      label={t(
        'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.airbnbMappingType',
      )}
      options={AIRBNB_OPTIONS}
      icon={<AirbnbIcon />}
      labelInputSizes={labelInputSizes}
      channel={Channel.airbnb}
      onChangeHandler={handleTypeChange}
      propertyUid={propertyUid}
    />
  );
};

export default AirbnbMappingTypeField;
